export const listStatusBooking = [
  'Chưa xác nhận',
  'Đã xác nhận',
  'Chờ phục vụ',
  'Đang phục vụ',
  'Hủy lịch',
  'Không đến',
  'Hoàn thành'
]